import { useScrollReveal } from '../../../hooks/useScrollReveal';

const steps = [
  {
    num: '01',
    icon: 'ri-chat-quote-line',
    title: 'Brief',
    subtitle: 'On vous écoute',
    description:
      'Un appel de 30 minutes suffit. Vous nous présentez votre offre, vos cibles, vos objectifs. On prend tout en note et on calibre votre équipe commerciale.',
    duration: 'Durée : 30 min',
  },
  {
    num: '02',
    icon: 'ri-rocket-2-line',
    title: 'Déploiement',
    subtitle: 'On s\'active',
    description:
      'Notre équipe se forme à votre offre, prépare les scripts, charge le CRM et lance les premières actions commerciales. Opérationnel sous 48h.',
    duration: 'Délai : 48h',
  },
  {
    num: '03',
    icon: 'ri-trophy-line',
    title: 'Résultats',
    subtitle: 'Vous signez',
    description:
      'Vous recevez des leads qualifiés, des RDV planifiés et des reportings précis. On ajuste la stratégie en continu pour maximiser vos performances.',
    duration: 'Dès la 1ère semaine',
  },
];

export default function Processus() {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section id="processus" className="bg-[#0A0A0A] py-24 lg:py-32 relative overflow-hidden">
      {/* Decoration */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxjaXJjbGUgY3g9IjMwIiBjeT0iMzAiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDEwNyw1MywwLjA4KSIvPjwvZz48L3N2Zz4=')] opacity-50" />

      <div ref={ref} className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div
          className={`text-center mb-20 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="inline-block text-[#6ECFA0] text-sm font-bold uppercase tracking-widest mb-4">
            Comment ça marche
          </span>
          <h2 className="text-4xl lg:text-5xl font-black text-white leading-tight mb-3">
            Simple. Rapide. Efficace.
          </h2>
          <p className="text-[#00C97B] text-lg font-semibold">En 3 étapes, votre force commerciale est en place</p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connecting line (desktop) */}
          <div className="hidden lg:block absolute top-16 left-0 right-0 h-0.5 mx-32">
            <div className="w-full h-full bg-gradient-to-r from-[#6ECFA0]/20 via-[#6ECFA0] to-[#6ECFA0]/20" />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
            {steps.map((step, i) => (
              <div
                key={step.title}
                className={`flex flex-col items-center text-center transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${i * 180}ms` }}
              >
                {/* Circle */}
                <div className="relative mb-8">
                  <div className="w-32 h-32 flex items-center justify-center rounded-full bg-[#6ECFA0] shadow-lg shadow-[#6ECFA0]/30">
                    <span className="text-3xl font-black text-black">{step.num}</span>
                  </div>
                  <div className="absolute -bottom-3 left-1/2 -translate-x-1/2 w-8 h-8 flex items-center justify-center rounded-full bg-[#1A1A1A] border-2 border-[#6ECFA0]/40">
                    <i className={`${step.icon} text-sm text-[#6ECFA0]`} />
                  </div>
                </div>

                {/* Content */}
                <div className="bg-[#141414] border border-white/5 rounded-2xl p-8 w-full hover:border-[#6ECFA0]/30 transition-colors duration-300">
                  <span className="text-xs font-bold text-[#6ECFA0] uppercase tracking-widest">{step.subtitle}</span>
                  <h3 className="text-2xl font-black text-white mt-2 mb-4">{step.title}</h3>
                  <p className="text-sm text-white/60 leading-relaxed mb-6">{step.description}</p>
                  <span className="inline-block bg-[#6ECFA0]/10 text-[#6ECFA0] text-xs font-bold px-4 py-2 rounded-full">
                    {step.duration}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
